import(/* webpackMode: "eager" */ "/builds/dustintech/products/openweb-nordics/web/libraries/dustin-microsite/apps/contentsite/src/app/error.tsx");
